import Image from 'react-bootstrap/Image';
import Img1 from './Images/IMG1.jpg';
import Img2 from './Images/IMG2.jpg';
import Footer from '../Footer/Footer';
import '../App.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Contact from '../Contact/Contact';
import { Link } from 'react-router-dom';

function Home() {
    return (
        <Container fluid>
            <Row>
           
                <Col>
                        <Image src={Img1} style={{ width: "-webkit-fill-available" }} />
                </Col>

                <Col lg={12} style={{ textAlign: "center", paddingTop: "30px" }}>
                    <ul style={{ listStyleType: "none" }}>
                        <li><h3>MENTAL HEALTH IS YOUR RESPONSIBILITY</h3></li>
                        <li><h3>IT IS YOUR PRIORITY</h3></li>
                        <li><h3>SO PLEASE TAKE CARE OF YOU</h3></li>
                    </ul>
                    <p>
                        Head Shrinker is a mental health platform that provides services to individuals ( children and
                        adult), couples, and families throughout our country
                    </p>
                </Col>
            </Row>
            <Row>
                <Col lg={5} style={{ paddingTop: "30px" }}>
                    <Image src={Img2} style={{
                        width: "-webkit-fill-available", objectFit: "cover"
                    }} />
                </Col>
                <Col lg={7} style={{ paddingTop: "30px" }}>
                    <h4>About Me</h4>
                    <p>Hello, I' m RCI licensed clinical psychologist with over four years of experience in the field of
                        mental health. I also focus on a holistic approach with clients to maintain wellbeing and to
                        promote strong therapeutic alliance.</p>
                    <p> I'm skilled in comprehensive psychometric assessments
                        and formulating therapy based on the needs of the client.</p>
                    <p>I strive to create a safe and
                        comfortable environment for my client</p>
                    <p>Contact us today, let's begin the process of improving you and relationships! </p>
                    <Link to="/about"> <Button style={{ backgroundColor: "#6883BC", borderRadius: "0", border: "none" }}>Know More</Button></Link>
                </Col>
            </Row>
            <Row style={{ paddingTop: "30px" }}>
                <Contact />
            </Row>
            <Row style={{ paddingTop: "30px", paddingBottom: "30px" }}><Col lg={12}><Footer /></Col></Row>
        </Container>

    );
}

export default Home;